module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-02-94d246391f8a787bbd2e23386d23dad2.jpg";